import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { RibbonControlProps } from 'owa-acui';
import { owaComputedFn } from 'owa-computed-fn';
import { getSharedControlInfo } from 'owa-mail-ribbon-utils/lib/getSharedControlInfo';
import {
    type RibbonIconColor,
    getRibbonIconModeColor,
} from 'owa-command-ribbon/lib/util/ribbonIconModeColors';
import { type MailRibbonControlId } from 'owa-ribbon-ids/lib/mailRibbonId';
import { getQuickStepGalleryStyles, getQuickStepsGalleryItems } from '../../util/quickStepsUtils';
import { onQuickStepsMenuClicked } from '../utils/deferredOnQuickStepsMenuClicked';
import { onQuickStepGalleryButtonExecute } from 'owa-mail-ribbon-command-actions/lib/quickStepsCommandActions';
import { resetMenuDefinitionMutator } from '../../mutatorActions/menuDefinitionMutatorActions';
import { getMenuDefinition } from '../../store/menuDefinitionStore';
import { getReadRibbonId } from 'owa-mail-ribbon-utils/lib/getReadRibbonId';

export const getQuickStepsControl: (
    isSLR: boolean,
    props: ReadOnlyRibbonControlDefProps
) => RibbonControlProps = owaComputedFn(function getQuickStepsControl(
    isSLR: boolean,
    props: ReadOnlyRibbonControlDefProps
): RibbonControlProps {
    const galleryItems = getQuickStepsGalleryItems(isSLR, props);
    const controlInfo = getSharedControlInfo(550, props);
    const storeName = 'QuickStepsMenuDefinitionStore';

    return {
        type: 'AppIconPreviewGalleryProps',
        id: getReadRibbonId(550, props.itemId).toString(),
        galleryButtons: galleryItems,
        onGalleryButtonExecute: onQuickStepGalleryButtonExecute(props),
        onMenuButtonExecute: () => onQuickStepsMenuClicked(props),
        onAfterMenuDismiss: () => resetMenuDefinitionMutator(storeName, props.projectionTabId),
        expandedOptions: getMenuDefinition(storeName, props.projectionTabId),
        stack: true,
        styles: getQuickStepGalleryStyles(isSLR, galleryItems.length),
        shadowRenderMenu: false,
        flyoutAnchorProps: {
            label: controlInfo.text,
            icon: controlInfo.iconName,
            styles: {
                icon: {
                    color: getRibbonIconModeColor(2),
                },
            },
        },
        menuLauncherLabel: controlInfo.ariaText,
    };
});
